/**
 * Seeded pseudo-random number generator using mulberry32 algorithm.
 * Provides deterministic random numbers from a given seed.
 */
export class SeededRNG {
  constructor(seed) {
    // Convert string seeds to numeric
    if (typeof seed === 'string') {
      let hash = 0;
      for (let i = 0; i < seed.length; i++) {
        hash = ((hash << 5) - hash + seed.charCodeAt(i)) | 0;
      }
      seed = Math.abs(hash);
    }
    this._state = seed | 0;
    if (this._state === 0) this._state = 1;
  }

  /**
   * Returns a float in [0, 1).
   */
  next() {
    let t = this._state += 0x6D2B79F5;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /**
   * Returns an integer in [min, max] (inclusive).
   */
  nextInt(min, max) {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }

  /**
   * Returns true or false with equal probability.
   */
  nextBool() {
    return this.next() < 0.5;
  }
}
